import migrationInfoTemplate from './migrationInfo.html';

angular.module('org.saga.migrationInfo', [])

   .factory('MigrationInfoDialog', ['$mdDialog', '$log', function($mdDialog, $log) {

      return {
         show: function(data, callback) {
            function DialogController($scope, $log, $mdDialog) {

               $scope.warnings = data.resultList;
               $scope.count = data.count;

               $scope.cancel = function() {
                  $mdDialog.cancel();
               };

               $scope.ok = function() {
                  $mdDialog.hide();
               };
            }

            $mdDialog.show({
               controller: ['$scope', '$log', '$mdDialog', DialogController],
               template: migrationInfoTemplate,
               parent: angular.element(document.body),
               clickOutsideToClose: true
            })
               .then(function() {
                  callback();
               }, function() {
                  // modal cancelled
               });

         }
      };
   }]);
